import { render, staticRenderFns } from "./allocationStorehouseHistoryAuditOrdersList.vue?vue&type=template&id=2bb95d68&scoped=true"
import script from "./allocationStorehouseHistoryAuditOrdersList.vue?vue&type=script&lang=js"
export * from "./allocationStorehouseHistoryAuditOrdersList.vue?vue&type=script&lang=js"
import style0 from "./allocationStorehouseHistoryAuditOrdersList.vue?vue&type=style&index=0&id=2bb95d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb95d68",
  null
  
)

export default component.exports